import { Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionStatus, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { filter, Observable, retry, of } from 'rxjs';
import { environment } from 'src/environments/environment';

// Specifies where the user is directed to after they sign out
const LOGOUT_URL = 'https://servicepage.liberty-healthcare.com/CGWeb/MainUI/ServiceCatalog/ServiceCatalog.aspx';

@Injectable()
export class AuthService {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService) {
  }
  login(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        retry(2),
        filter((status: InteractionStatus) => status === InteractionStatus.None),
      )
      .subscribe(async () => {
        this.checkToken();
      });
  }

  checkToken(): Observable<void> {
    let tokenObservable: Observable<void>;
    if (this.authService.instance.getActiveAccount() == null) {
      console.log('Token Requires Refresh');
      if (this.msalGuardConfig.authRequest) {
        tokenObservable = this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        tokenObservable = this.authService.loginRedirect();
      }
      this.authenticateUser();
    }

    return tokenObservable ?? of(undefined);
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
    this.authService.instance.clearCache();
  }

  private authenticateUser() {
    const authenticatedUser = this.authService.instance.getAllAccounts()[0];
    if (authenticatedUser) {
      console.log('AUTHENTICATION NAME: ', authenticatedUser);

      this.authService.instance.setActiveAccount(authenticatedUser);
    }
  }
}

export function MSALInstanceFactory(isIE: boolean): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: environment.authority,
      redirectUri: `${window.location.origin}${environment.redirectUri}`,
      postLogoutRedirectUri: LOGOUT_URL,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      allowRedirectInIframe: true,
      loggerOptions: {
        loggerCallback: () => { },
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.backendUrl, [environment.scopeUri]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.scopeUri],
    },
  };
}
